import ControlWrapper from './ControlWrapper'
export default ControlWrapper


// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/index.js